import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faGithub,
	faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import Educations from "../components/educations/educations";
import ExperienceList from "../components/experienceList/experienceList";
import ProjectsList from "../components/projectsList/projectsList";
import TextPressure from "../animations/TextPressure";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/home.css";

const Home = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "home");

	return (
		<React.Fragment>
			<Helmet>
				<title>{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="home" />
				<div className="content-wrapper">
					<div className="home-container">
						<div className="home-first-area">
							<div className="home-first-area-left-side">
								<h1 className="title home-title">
									<TextPressure
										text="Hello!"
										flex={true}
										alpha={false}
										stroke={false}
										width={true}
										weight={true}
										italic={true}
										textColor="#27272a"
										strokeColor="#ff0000"
										minFontSize={36}
									/>
									
									<p>{INFO.homepage.title}</p>
								</h1>

								<div className="subtitle home-subtitle">
								{INFO.homepage.descriptions}
								</div>
							</div>

							<div className="home-first-area-right-side">
								<div className="home-image-container">
									<div className="home-image-wrapper">
										<img
											src="cat.gif"
											alt="cat coding"
											className="home-image"
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="home-socials">
							<a
								className="home-social-link"
								href={INFO.socials.linkedin}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faLinkedin}
									className="home-social-icon"
								/>
							</a>
							<a
								className="home-social-link"
								href={INFO.socials.github}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faGithub}
									className="home-social-icon"
								/>
							</a>
							<a
								className="home-social-link"
								href={`mailto:${INFO.main.email}`}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faMailBulk}
									className="home-social-icon"
								/>
							</a>
						</div>

						<div className="home-session">
							<h2 className="home-session-title">Educations</h2>
							<Educations />
						</div>
						<div className="home-session">
							<h2 className="home-session-title">Experiences</h2>
							<ExperienceList />
						</div>
						<div className="home-session">
							<h2 className="home-session-title">Projects</h2>
							<ProjectsList />
						</div>

						<div className="page-footer">
							<Footer />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Home;
